// Single source of truth for the build marker shown to operators (drawer
// footer + App Update page). Bump this on each deploy.
export const APP_VERSION = 'v3.5.36 (web)';
